import { CollegeDetailsFragment } from 'generated/spin-graphql';
import React from 'react';
import { gql } from 'urql';
import { CollegeProfile } from './profile-page/CollegeProfile';

gql`
    fragment CollegeDetails on espin_college {
        ...CollegeProfile
    }
`;

export function CollegeDetails({ college }: { college: CollegeDetailsFragment }) {
    return (
        <div className="container college-profile-container">
            <CollegeProfile college={college} />
        </div>
    );
}
